import { render, staticRenderFns } from "./IconPlus.vue?vue&type=template&id=a98bcb56&scoped=true&"
import script from "./IconPlus.vue?vue&type=script&lang=js&"
export * from "./IconPlus.vue?vue&type=script&lang=js&"
import style0 from "./IconPlus.vue?vue&type=style&index=0&id=a98bcb56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98bcb56",
  null
  
)

export default component.exports